<template>
  <div id="promo">
    <div id="app_footer" class="reserved">
      <section id="promo">
        <div class="container">
          <h1>Scopri le nostre Promozioni</h1>
        </div>
        <div class="carousel">
          <div
            class="slide d-flex align-items-center"
            :style="{ left: 25 + move + 'vw' }"
          >
            <div
              class="item"
              v-for="(item, i) in carousel_items"
              :key="i"
              :style="{ backgroundImage: 'url(' + item + ')' }"
              :class="active_item == i ? 'active' : ''"
            >
              <div class="item-text flex-column">
                <h2 class="my-caps">prova testo item</h2>
                <a class="link-ret green btn btn-my-primary" href="">Scopri</a>
              </div>
            </div>
          </div>
          <div
            class="my-controls d-flex align-items-center justify-content-center"
          >
            <div class="my-prev" @click="prev()">
              <i class="fas fa-chevron-left"></i>
            </div>
            <div class="my-dots">
              <i
                v-for="(dot, i) in carousel_items.length"
                :key="i"
                :class="i == active_item ? 'fas' : 'far'"
                class="fa-circle dot"
                @click="select_item(i)"
              ></i>
            </div>
            <div class="my-next" @click="next()">
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueInstagram from 'vue-instagram'
export default {
  components: {VueInstagram},
  data: function () {
    return {
      carousel_items: [
        "/media/vetrina/FOTO 002.PNG",
        "/media/vetrina/FOTO 002.PNG",
        "/media/vetrina/FOTO 002.PNG",
        "/media/vetrina/FOTO 002.PNG",
      ],
      active_item: 0,
      move: 0,
    };
  },
  created: function () {
    var vue = this;
    setInterval(function () {
      vue.next();
    }, 5000);
  },
  methods: {
    prev: function () {
      if (this.active_item == 0) {
        this.active_item = this.carousel_items.length - 1;
        this.move = -50 * (this.carousel_items.length - 1);
      } else {
        this.active_item -= 1;
        this.move += 50;
      }
    },
    next: function () {
      if (this.active_item == this.carousel_items.length - 1) {
        this.active_item = 0;
        this.move = 0;
      } else {
        this.active_item += 1;
        this.move -= 50;
      }
    },
    select_item: function (i) {
      this.active_item = i;
      this.move = -50 * i;
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 62px;
  font-size: 32px;
}

.carousel {
  width: max-content;
  .slide {
    position: relative;
    left: 25vw;
    width: max-content;
    height: 27vw;
    transition: all 0.5s ease-in-out 0s;
    .item {
      width: 44vw;
      height: 24vw;
      margin: 0 3vw;
      display: inline-block;
      transition: all 0.5s ease-in-out 0s;
      background-size: cover;
      .item-text {
        display: none;
        transition: display 1s ease-in-out 1s;
        margin-top: 3vw;
        margin-left: 4vw;
        h2 {
          font-size: 24px;
          margin-bottom: 36px;
        }
      }
      &.active {
        width: 45vw;
        height: 27vw;
        .item-text {
          display: flex;
        }
      }
    }
  }
  .my-controls {
    color: #fff;
    position: absolute;
    width: 100vw;
    height: 80px;
    bottom: 0;
    background-color: rgba($color: #26262a, $alpha: 0.53);
    font-weight: 100;
    backdrop-filter: blur(10px);
    i {
      opacity: 0.53;
      font-size: 16px;

      &:hover {
        cursor: pointer;
        opacity: 1;
      }
    }
    .my-dots {
      margin: 0 176px;

      .dot {
        margin: 0 10px;
      }
    }
  }
}
</style>
